import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { ChartProperties } from '@nimbus-library/features/charts/models/chart.model';

@Component({
  selector: 'nimbus-chat-message-pie',
  standalone: false,
  templateUrl: './chat-message-pie.component.html',
  styleUrl: './chat-message-pie.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatMessagePieComponent {
  @Input({ required: true })
  public data$!: Observable<ChartProperties>;
}
